export default {
  Asset: "Tài sản",
  Import: {
    Asset: "Tên Tài sản",
  },
  demoLayout: {
    code: "Mã nhân viên",
    name: "Tên nhân viên",
    org: "Phòng ban",
    gender: "Giới tính",
    dob: "Ngày sinh",
    inactive: "Ngừng theo dõi",
    salary: "Lương",
    created: "Ngày Tạo",
  }
};
